import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  FaWhatsapp,
  FaMapMarkerAlt,
  FaLaptopCode,
  FaSearch,
  FaRocket,
  FaCheckCircle,
  FaMobileAlt,
  FaStore,
  FaArrowRight,
  FaStar,
  FaPhone,
} from "react-icons/fa";
import "./LocationLandingPage.css";

/* ─── Location Data ─────────────────────────────────────────── */
export const locationPages = {
  "web-developer-dahanu-road": {
    area: "Dahanu Road",
    keyword: "web developer Dahanu Road",
    title: "Web Developer in Dahanu Road | Amresh Prajapati",
    h1: "Web Developer in Dahanu Road",
    nearby: ["Palghar", "Boisar", "Vangaon"],
  },
  "web-developer-vangaon": {
    area: "Vangaon",
    keyword: "web developer Vangaon",
    title: "Web Developer in Vangaon | Amresh Prajapati",
    h1: "Web Developer in Vangaon",
    nearby: ["Dahanu Road", "Boisar", "Palghar"],
  },
  "website-designer-boisar": {
    area: "Boisar",
    keyword: "website designer Boisar",
    title: "Website Designer in Boisar | Affordable & Fast",
    h1: "Website Designer in Boisar",
    nearby: ["Palghar", "Umroli", "Dahanu Road"],
  },
  "web-developer-umroli": {
    area: "Umroli",
    keyword: "web developer Umroli",
    title: "Web Developer in Umroli | Amresh Prajapati",
    h1: "Web Developer in Umroli",
    nearby: ["Boisar", "Palghar", "Kelve Road"],
  },
  "website-development-palghar": {
    area: "Palghar",
    keyword: "website development Palghar",
    title: "Website Development in Palghar | Freelancer Near You",
    h1: "Website Development in Palghar",
    nearby: ["Boisar", "Kelve Road", "Saphale"],
  },
  "web-developer-kelve-road": {
    area: "Kelve Road",
    keyword: "web developer Kelve Road",
    title: "Web Developer in Kelve Road | Amresh Prajapati",
    h1: "Web Developer in Kelve Road",
    nearby: ["Palghar", "Saphale", "Vaitarna"],
  },
  "website-designer-saphale": {
    area: "Saphale",
    keyword: "website designer Saphale",
    title: "Website Designer in Saphale | Amresh Prajapati",
    h1: "Website Designer in Saphale",
    nearby: ["Kelve Road", "Vaitarna", "Virar"],
  },
  "web-developer-vaitarna": {
    area: "Vaitarna",
    keyword: "web developer Vaitarna",
    title: "Web Developer in Vaitarna | Amresh Prajapati",
    h1: "Web Developer in Vaitarna",
    nearby: ["Saphale", "Virar", "Vasai"],
  },
  "web-developer-virar": {
    area: "Virar",
    keyword: "web developer Virar",
    title: "Web Developer in Virar | Amresh Prajapati",
    h1: "Web Developer in Virar",
    nearby: ["Virar West", "Nallasopara", "Vasai Road"],
  },
  "web-developer-virar-west": {
    area: "Virar West",
    keyword: "web developer Virar West",
    title: "Web Developer in Virar West | Amresh Prajapati",
    h1: "Web Developer in Virar West",
    nearby: ["Virar", "Nallasopara", "Vasai"],
  },
  "website-designer-nallasopara": {
    area: "Nallasopara",
    keyword: "website designer Nallasopara",
    title: "Website Designer in Nallasopara | Affordable & Fast",
    h1: "Website Designer in Nallasopara",
    nearby: ["Virar", "Vasai Road", "Naigaon"],
  },
  "web-developer-vasai-road": {
    area: "Vasai Road",
    keyword: "web developer Vasai Road",
    title: "Freelance Web Developer in Vasai Road | Amresh Prajapati",
    h1: "Freelance Web Developer in Vasai Road",
    nearby: ["Nallasopara", "Vasai", "Naigaon"],
  },
  "web-developer-vasai": {
    area: "Vasai",
    keyword: "web developer Vasai",
    title: "Freelance Web Developer in Vasai | Amresh Prajapati",
    h1: "Freelance Web Developer in Vasai",
    nearby: ["Vasai Road", "Naigaon", "Bhayandar"],
  },
  "web-developer-naigaon": {
    area: "Naigaon",
    keyword: "web developer Naigaon",
    title: "Web Developer in Naigaon | Amresh Prajapati",
    h1: "Web Developer in Naigaon",
    nearby: ["Vasai", "Bhayandar", "Mira Road"],
  },
  "website-development-bhayandar": {
    area: "Bhayandar",
    keyword: "website development Bhayandar",
    title: "Website Development in Bhayandar | Freelancer Near You",
    h1: "Website Development in Bhayandar",
    nearby: ["Naigaon", "Mira Road", "Dahisar"],
  },
  "website-development-mira-road": {
    area: "Mira Road",
    keyword: "website development Mira Road",
    title: "Website Development in Mira Road | Freelancer Near You",
    h1: "Website Development in Mira Road",
    nearby: ["Bhayandar", "Dahisar", "Naigaon"],
  },
  "web-developer-dahisar": {
    area: "Dahisar",
    keyword: "web developer Dahisar",
    title: "Web Developer in Dahisar | Amresh Prajapati",
    h1: "Web Developer in Dahisar",
    nearby: ["Mira Road", "Bhayandar", "Borivali"],
  },

  /* ─── Mumbai Keyword Pages ────────────────────────────────── */
  "best-freelance-website-designer-mumbai": {
    area: "Mumbai",
    keyword: "Best Freelance Website Designer in Mumbai",
    title: "Best Freelance Website Designer in Mumbai | Amresh Prajapati",
    h1: "Best Freelance Website Designer in Mumbai",
    nearby: ["Virar", "Vasai", "Andheri", "Bandra", "Powai"],
  },
  "best-freelance-web-developer-mumbai": {
    area: "Mumbai",
    keyword: "Best Freelance Web Developer in Mumbai",
    title: "Best Freelance Web Developer in Mumbai | Amresh Prajapati",
    h1: "Best Freelance Web Developer in Mumbai",
    nearby: ["Virar", "Vasai", "Borivali", "Malad", "Andheri"],
  },
  "affordable-freelance-website-designer-mumbai": {
    area: "Mumbai",
    keyword: "Affordable Freelance Website Designer Mumbai",
    title: "Affordable Freelance Website Designer Mumbai | Amresh Prajapati",
    h1: "Affordable Freelance Website Designer Mumbai",
    nearby: ["Virar", "Vasai", "Nallasopara", "Bhayandar", "Mira Road"],
  },
  "professional-freelance-web-developer-mumbai": {
    area: "Mumbai",
    keyword: "Professional Freelance Web Developer Mumbai",
    title: "Professional Freelance Web Developer Mumbai | Amresh Prajapati",
    h1: "Professional Freelance Web Developer Mumbai",
    nearby: ["Virar", "Vasai", "Andheri", "Goregaon", "Malad"],
  },
  "react-js-freelance-developer-mumbai": {
    area: "Mumbai",
    keyword: "React JS Freelance Developer Mumbai",
    title: "React JS Freelance Developer Mumbai | Amresh Prajapati",
    h1: "React JS Freelance Developer Mumbai",
    nearby: ["Virar", "Vasai", "Andheri", "Bandra", "Nariman Point"],
  },
  "php-freelance-developer-mumbai": {
    area: "Mumbai",
    keyword: "PHP Freelance Developer Mumbai",
    title: "PHP Freelance Developer Mumbai | Amresh Prajapati",
    h1: "PHP Freelance Developer Mumbai",
    nearby: ["Virar", "Vasai", "Borivali", "Andheri", "Thane"],
  },
  "ecommerce-website-developer-mumbai": {
    area: "Mumbai",
    keyword: "E-commerce Website Developer Mumbai",
    title: "E-commerce Website Developer Mumbai | Amresh Prajapati",
    h1: "E-commerce Website Developer Mumbai",
    nearby: ["Virar", "Vasai", "Andheri", "Bandra", "Powai"],
  },
  "custom-website-developer-mumbai": {
    area: "Mumbai",
    keyword: "Custom Website Developer Mumbai",
    title: "Custom Website Developer Mumbai | Amresh Prajapati",
    h1: "Custom Website Developer Mumbai",
    nearby: ["Virar", "Vasai", "Andheri", "Goregaon", "Thane"],
  },
  "wordpress-website-designer-mumbai": {
    area: "Mumbai",
    keyword: "WordPress Website Designer Mumbai",
    title: "WordPress Website Designer Mumbai | Amresh Prajapati",
    h1: "WordPress Website Designer Mumbai",
    nearby: ["Virar", "Vasai", "Borivali", "Andheri", "Dadar"],
  },
  "website-designer-near-me-mumbai": {
    area: "Mumbai",
    keyword: "Website Designer Near Me Mumbai",
    title: "Website Designer Near Me Mumbai | Amresh Prajapati",
    h1: "Website Designer Near Me Mumbai",
    nearby: ["Virar", "Vasai", "Nallasopara", "Andheri", "Bandra"],
  },
};

/* ─── Animated counter hook ─────────────────────────────────── */
function useCounter(end, duration = 1600, start = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [end, duration, start]);
  return count;
}

/* ─── Stats section with intersection observer ──────────────── */
function StatsSection({ area }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const c1 = useCounter(50, 1400, visible);
  const c2 = useCounter(98, 1600, visible);
  const c3 = useCounter(5, 1200, visible);
  const c4 = useCounter(100, 1500, visible);

  return (
    <div className="lp-stats" ref={ref}>
      {[
        { val: c1, suffix: "+", label: "Projects Completed" },
        { val: c2, suffix: "%", label: "Client Satisfaction" },
        { val: c3, suffix: "+", label: "Years Experience" },
        { val: c4, suffix: "%", label: "Mobile Responsive" },
      ].map(({ val, suffix, label }) => (
        <div className="lp-stat" key={label}>
          <span className="lp-stat-num">{val}{suffix}</span>
          <span className="lp-stat-label">{label}</span>
        </div>
      ))}
    </div>
  );
}

/* ─── Services data ──────────────────────────────────────────── */
const services = [
  { icon: <FaLaptopCode />, title: "Custom Website Development", text: "Handcrafted websites built around your goals — not templates. Every page designed to convert visitors into customers." },
  { icon: <FaMobileAlt />, title: "Mobile-First Design", text: "Over 70% of visitors come from phones. Your website will look sharp and work flawlessly on every screen size." },
  { icon: <FaSearch />, title: "Local SEO Setup", text: "Proper meta tags, schema markup, location keywords and sitemap setup so Google finds your business fast." },
  { icon: <FaRocket />, title: "Performance Optimized", text: "Lean code, compressed images and smart loading strategies for a website that scores green on every speed test." },
  { icon: <FaStore />, title: "Business & Ecommerce", text: "From service sites and portfolios to full ecommerce stores — built with the right tools for your type of business." },
  { icon: <FaCheckCircle />, title: "Direct Developer Support", text: "No middlemen. You speak directly with me. Faster decisions, transparent process and personal accountability." },
];

/* ─── Process steps ─────────────────────────────────────────── */
const steps = [
  { n: "01", title: "Discuss Requirements", text: "We talk about your business, audience, pages and goals over call or WhatsApp." },
  { n: "02", title: "Design & Build", text: "I create a modern responsive design and develop with clean, optimised code." },
  { n: "03", title: "SEO & Launch", text: "Meta setup, speed checks, mobile testing, schema markup and go-live support." },
];

/* ─── Main component ─────────────────────────────────────────── */
export default function LocationLandingPage({ slug }) {
  const data = locationPages[slug];
  if (!data) return null;

  const { area, keyword, title, h1, nearby = [] } = data;

  const description = `Looking for a reliable ${keyword}? Amresh Prajapati builds fast, mobile-friendly, SEO-optimized websites for businesses in ${area} — 4+ years experience, 70+ projects, React & WordPress expertise. Call or WhatsApp +91 90040 68462 for a free quote today!`;

  const keywords = [
    keyword,
    `freelance web developer ${area}`,
    `website developer near me ${area}`,
    `React developer ${area}`,
    `ecommerce website ${area}`,
    `affordable website design ${area}`,
    `best web developer ${area}`,
    `business website ${area}`,
    `WordPress developer ${area}`,
    `SEO website ${area}`,
    `web designer ${area}`,
    `website development services ${area}`,
    ...nearby.map((n) => `web developer ${n}`),
  ].join(", ");

  /* JSON-LD schema */
  const schemaOrg = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "@id": `https://freelanceramreshprajapatimumbai.in/${slug}#business`,
        name: "Amresh Prajapati - Web Developer",
        url: `https://freelanceramreshprajapatimumbai.in/${slug}`,
        telephone: "+919004068462",
        image: "https://freelanceramreshprajapatimumbai.in/og-image.jpg",
        description,
        address: {
          "@type": "PostalAddress",
          addressLocality: area,
          addressRegion: "Maharashtra",
          addressCountry: "IN",
        },
        areaServed: [area, ...nearby, "Virar", "Vasai", "Nallasopara", "Mumbai"],
        geo: { "@type": "GeoCoordinates", latitude: 19.4595, longitude: 72.8047 },
        openingHours: "Mo-Su 00:00-23:59",
        priceRange: "₹₹",
        sameAs: [
          "https://www.linkedin.com/in/amreshprajapati",
          "https://github.com/amreshprajapati",
        ],
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "Web Development Services",
          itemListElement: [
            { "@type": "Offer", itemOffered: { "@type": "Service", name: `Custom Website Development in ${area}` } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: `React Web App Development in ${area}` } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: `Ecommerce Website in ${area}` } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: `Local SEO Setup in ${area}` } },
          ],
        },
      },
      {
        "@type": "Person",
        "@id": "https://freelanceramreshprajapatimumbai.in/#person",
        name: "Amresh Prajapati",
        jobTitle: "Freelance Web Developer",
        url: "https://freelanceramreshprajapatimumbai.in",
        worksFor: { "@type": "Organization", name: "Amresh Prajapati - Freelancer" },
        knowsAbout: ["React", "JavaScript", "Web Development", "SEO", "WordPress"],
      },
      {
        "@type": "WebPage",
        "@id": `https://freelanceramreshprajapatimumbai.in/${slug}#webpage`,
        url: `https://freelanceramreshprajapatimumbai.in/${slug}`,
        name: title,
        description,
        isPartOf: { "@id": "https://freelanceramreshprajapatimumbai.in/#website" },
        about: { "@id": `https://freelanceramreshprajapatimumbai.in/${slug}#business` },
        breadcrumb: {
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://freelanceramreshprajapatimumbai.in" },
            { "@type": "ListItem", position: 2, name: area, item: `https://freelanceramreshprajapatimumbai.in/${slug}` },
          ],
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: `How much does website development cost in ${area}?`,
            acceptedAnswer: {
              "@type": "Answer",
              text: `Website development cost in ${area} starts from ₹8,000 for a basic business site and goes up depending on pages, features and complexity. Contact Amresh Prajapati for a free quote.`,
            },
          },
          {
            "@type": "Question",
            name: `Do you provide website development services in ${area}?`,
            acceptedAnswer: {
              "@type": "Answer",
              text: `Yes, Amresh Prajapati provides professional website development services in ${area} including custom websites, React apps, ecommerce stores and local SEO setup.`,
            },
          },
          {
            "@type": "Question",
            name: `How long does it take to build a website in ${area}?`,
            acceptedAnswer: {
              "@type": "Answer",
              text: `A standard business website in ${area} takes 5–10 working days. React apps or ecommerce stores may take 2–4 weeks depending on requirements.`,
            },
          },
        ],
      },
    ],
  };

  const waLink = (msg) =>
    `https://wa.me/919004068462?text=${encodeURIComponent(msg)}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={`https://freelanceramreshprajapatimumbai.in/${slug}`} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={`https://freelanceramreshprajapatimumbai.in/${slug}`} />
        <meta property="og:image" content="https://freelanceramreshprajapatimumbai.in/og-image.jpg" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:site_name" content="Amresh Prajapati" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="https://freelanceramreshprajapatimumbai.in/og-image.jpg" />

        {/* Extra SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Amresh Prajapati" />
        <meta name="geo.region" content="IN-MH" />
        <meta name="geo.placename" content={area} />

        {/* Schema JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify(schemaOrg)}
        </script>
      </Helmet>

      <main className="lp-root">

        {/* ── HERO ──────────────────────────────────────────────── */}
        <section className="lp-hero">
          <div className="lp-hero-noise" />
          <div className="lp-hero-orb lp-hero-orb-1" />
          <div className="lp-hero-orb lp-hero-orb-2" />
          <div className="lp-hero-orb lp-hero-orb-3" />

          {/* Floating grid lines */}
          <div className="lp-grid-lines" aria-hidden="true">
            {[...Array(5)].map((_, i) => <span key={i} className="lp-vline" />)}
          </div>

          <div className="lp-wrap lp-hero-inner">
            <div className="lp-hero-left">
              <div className="lp-eyebrow">
                <FaMapMarkerAlt />
                <span>Available in {area} &amp; Nearby Areas</span>
              </div>

              <h1 className="lp-hero-h1">
                {h1.split(area).map((part, i, arr) => (
                  <React.Fragment key={i}>
                    {part}
                    {i < arr.length - 1 && (
                      <em className="lp-accent-text">{area}</em>
                    )}
                  </React.Fragment>
                ))}
              </h1>

              <p className="lp-hero-desc">
                I'm Amresh Prajapati — a freelance website developer who builds
                fast, modern and SEO-ready websites for local businesses in{" "}
                {area}. Clean code, real results, direct support.
              </p>

              <div className="lp-hero-ctas">
                <a
                  href={waLink(`Hello Amresh, I need website development in ${area}.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lp-btn lp-btn-primary"
                >
                  <FaWhatsapp /> WhatsApp Now
                </a>
                <Link to="/contact" className="lp-btn lp-btn-ghost">
                  Get Free Quote <FaArrowRight />
                </Link>
              </div>

              <div className="lp-trust-row">
                <div className="lp-stars">
                  {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                </div>
                <span>Trusted by 50+ businesses across Western Line</span>
              </div>
            </div>

            <div className="lp-hero-right">
              <div className="lp-hero-card">
                <div className="lp-hero-card-header">
                  <span className="lp-online-dot" />
                  <span>Available for new projects</span>
                </div>

                <h2>Website Services<br />in {area}</h2>

                <ul className="lp-feature-list">
                  {[
                    "Custom Business Websites",
                    "React Apps & Landing Pages",
                    "WordPress Development",
                    "Ecommerce Stores",
                    "Local SEO & Schema Setup",
                    "WhatsApp CTA Integration",
                  ].map((f) => (
                    <li key={f}>
                      <FaCheckCircle className="lp-check" />
                      {f}
                    </li>
                  ))}
                </ul>

                <a
                  href={waLink(`Hello Amresh, I am from ${area} and need a website.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lp-btn lp-btn-primary lp-btn-full"
                >
                  <FaPhone /> Call / WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ── STATS ─────────────────────────────────────────────── */}
        <section className="lp-stats-section">
          <div className="lp-wrap">
            <StatsSection area={area} />
          </div>
        </section>

        {/* ── SERVICES ──────────────────────────────────────────── */}
        <section className="lp-services">
          <div className="lp-wrap">
            <div className="lp-section-label">What I Build</div>
            <div className="lp-services-header">
              <h2>
                Affordable Website Development<br />
                <span>Services in {area}</span>
              </h2>
              <p>
                Every website I build is crafted to help your business get more
                calls, enquiries and customers — not just to look good.
              </p>
            </div>

            <div className="lp-services-grid">
              {services.map((s, i) => (
                <div className="lp-service-card" key={s.title} style={{ "--delay": `${i * 0.07}s` }}>
                  <div className="lp-service-icon">{s.icon}</div>
                  <h3>{s.title}</h3>
                  <p>{s.text}</p>
                  <div className="lp-service-line" />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── WHY SECTION ───────────────────────────────────────── */}
        <section className="lp-why">
          <div className="lp-why-bg" />
          <div className="lp-wrap lp-why-inner">
            <div className="lp-why-content">
              <div className="lp-section-label">Local Website Expert</div>
              <h2>Why Businesses in {area}<br />Need a Strong Website</h2>
              <p>
                Today, customers search online before calling any business. If
                your website is slow, outdated or hard to use on a phone,
                visitors leave without contacting you. A well-designed website
                gives your business a professional identity and turns online
                searches into real enquiries.
              </p>
              <p>
                For local businesses in {area}, a website is not just a digital
                brochure — it is a 24/7 lead generation tool. Whether you run a
                shop, clinic, coaching class, real estate firm, startup or
                service business, your website should clearly show what you
                offer, why people should choose you and how to reach you in
                seconds.
              </p>
              <p>
                I build websites with a mobile-first approach, clean call-to-action
                sections, WhatsApp contact links, local SEO meta tags and schema
                markup. These details make a direct impact when your goal is
                getting more calls from Google searches in {area}.
              </p>

              <div className="lp-why-tags">
                {["Shops", "Clinics", "Coaching Classes", "Startups", "Real Estate", "Consultants", "Service Providers", "Freelancers"].map((t) => (
                  <span key={t} className="lp-tag">{t}</span>
                ))}
              </div>
            </div>

            <div className="lp-why-aside">
              <div className="lp-aside-card">
                <h3>Best For</h3>
                <ul>
                  {["Local Businesses in " + area, "Startups & Agencies", "Coaching Classes", "Clinics & Consultants", "Shops & Service Providers", "Portfolio Websites", "Landing Pages", "Ecommerce Websites"].map((i) => (
                    <li key={i}><span className="lp-dot" />{i}</li>
                  ))}
                </ul>
              </div>

              <div className="lp-aside-cta">
                <p>Ready to start?</p>
                <a
                  href={waLink(`Hello Amresh, I am from ${area} and want a website for my business.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lp-btn lp-btn-primary lp-btn-full"
                >
                  <FaWhatsapp /> Start on WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ── PROCESS ───────────────────────────────────────────── */}
        <section className="lp-process">
          <div className="lp-wrap">
            <div className="lp-section-label center">Simple Process</div>
            <h2 className="lp-process-title">
              From First Chat to<br />
              <span>Live Website — 3 Steps</span>
            </h2>

            <div className="lp-process-track">
              <div className="lp-process-line" />
              {steps.map((s, i) => (
                <div className="lp-process-step" key={s.n}>
                  <div className="lp-process-num">{s.n}</div>
                  <h3>{s.title}</h3>
                  <p>{s.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── SEO CONTENT ───────────────────────────────────────── */}
        <section className="lp-seo-section">
          <div className="lp-wrap lp-seo-inner">
            <div className="lp-seo-aside">
              <div className="lp-aside-card accent">
                <h3>What You Get</h3>
                <ul>
                  {[
                    "Responsive website design",
                    "SEO title & meta setup",
                    "Schema markup (JSON-LD)",
                    "WhatsApp CTA integration",
                    "Fast loading structure",
                    "Clean modern UI",
                    "Contact form support",
                    "Sitemap & robots.txt",
                    "Google Search Console setup",
                    "Google-friendly layout",
                  ].map((i) => (
                    <li key={i}><span className="lp-dot accent" />{i}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="lp-seo-content">
              <div className="lp-section-label">SEO Ready Website</div>
              <h2>Built for Performance,<br /><span>Trust &amp; Enquiries</span></h2>
              <p>
                My main focus is to create a website that not only looks premium
                but also supports your business growth. A proper website guides
                visitors naturally from the hero section to the contact button —
                through services, benefits, social proof and a clear call to
                action.
              </p>
              <p>
                For local SEO, location pages like this target keywords such as{" "}
                <strong>{keyword}</strong>, freelance web developer in {area},
                website designer near {area} and affordable website development
                services in {area}. When added to your sitemap and indexed
                correctly, these pages drive long-term organic traffic.
              </p>
              <p>
                Every website I build includes proper schema markup (LocalBusiness,
                FAQPage, BreadcrumbList), Open Graph tags for social sharing,
                sitemap.xml, robots.txt, Google Search Console integration and
                canonical URL setup. These technical SEO elements are often
                ignored but make a significant difference in how quickly your
                website ranks.
              </p>
              <p>
                If you want a reliable {keyword} who handles everything from
                design to launch and SEO — I'm ready to help. Let's build a
                website that brings real enquiries from {area} and nearby areas
                like {nearby.join(", ")}.
              </p>
            </div>
          </div>
        </section>

        {/* ── FAQ ───────────────────────────────────────────────── */}
        <section className="lp-faq">
          <div className="lp-wrap">
            <div className="lp-section-label center">FAQ</div>
            <h2 className="lp-faq-title">Common Questions from<br /><span>{area} Clients</span></h2>

            <div className="lp-faq-grid">
              {[
                {
                  q: `How much does website development cost in ${area}?`,
                  a: `Website development in ${area} starts from ₹8,000 for a basic business site. The cost depends on pages, features and complexity. Contact for a free custom quote.`,
                },
                {
                  q: `How long does it take to build a website?`,
                  a: `A standard business website takes 5–10 working days. Ecommerce or React apps may take 2–4 weeks depending on requirements.`,
                },
                {
                  q: `Do you provide support after the website goes live?`,
                  a: `Yes. I provide post-launch support for edits, updates, fixes and WhatsApp guidance. Direct developer support — no middlemen.`,
                },
                {
                  q: `Will my website work on mobile phones?`,
                  a: `Absolutely. Every website I build is 100% mobile responsive and tested on phones, tablets and desktops before launch.`,
                },
                {
                  q: `Can you help my website rank on Google in ${area}?`,
                  a: `Yes. I set up on-page SEO, meta tags, schema markup, Google Search Console and sitemap — giving your website the best chance to rank locally.`,
                },
                {
                  q: `Do you build React and WordPress websites?`,
                  a: `Yes, I work with React.js for modern web apps and WordPress for content-based business sites. The technology is chosen based on your business needs.`,
                },
              ].map(({ q, a }) => (
                <div className="lp-faq-item" key={q}>
                  <h3>{q}</h3>
                  <p>{a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── NEARBY AREAS ──────────────────────────────────────── */}
        {nearby.length > 0 && (
          <section className="lp-nearby">
            <div className="lp-wrap">
              <p className="lp-nearby-label">Also serving nearby areas</p>
              <div className="lp-nearby-chips">
                {nearby.map((n) => (
                  <span key={n} className="lp-chip">{n}</span>
                ))}
                <span className="lp-chip">Virar</span>
                <span className="lp-chip">Vasai</span>
                <span className="lp-chip">Nallasopara</span>
                <span className="lp-chip">Mumbai</span>
              </div>
            </div>
          </section>
        )}

        {/* ── CTA BANNER ────────────────────────────────────────── */}
        <section className="lp-cta-banner">
          <div className="lp-cta-orb-1" />
          <div className="lp-cta-orb-2" />
          <div className="lp-wrap lp-cta-inner">
            <div>
              <h2>Need a Website in {area}?</h2>
              <p>Let's build something fast, beautiful and built to rank.</p>
            </div>
            <div className="lp-cta-btns">
              <a
                href={waLink(`Hello Amresh, I am from ${area} and need a website.`)}
                target="_blank"
                rel="noopener noreferrer"
                className="lp-btn lp-btn-primary"
              >
                <FaWhatsapp /> WhatsApp Now
              </a>
              <Link to="/contact" className="lp-btn lp-btn-ghost">
                Request a Quote <FaArrowRight />
              </Link>
            </div>
          </div>
        </section>

      </main>
    </>
  );
}
